import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { UserInfoService } from "../user-info.service";
import { TaxYearsService } from "../../shared/util/tax-years.service";
import { ConfigStateService } from "../config/config-state.service";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { TranslocoService} from "@jsverse/transloco";
import { LanguageService } from "../../../swaggerServices";
import { TenantConfigService } from "../../shared/services/tenant-config.service";
import { LanguageType, Language_Local_Storage} from  "../../shared/types/language.enum";


declare const $: any;
@Component({
    selector: "app-navbar",
    templateUrl: "./navbar.component.html",
    styleUrls: ["./navbar.component.scss"],
    standalone: false
})
export class NavbarComponent implements OnInit {
  menu: Array<{
    routerLink: string
    queryParams?: any
    label: string
    className: string
    semanticUiIcon?: string
    admin: boolean
    clientAdmin?: boolean
    visible?: () => boolean
  }>;

  @ViewChild('overlay') overlayEl: ElementRef;
  formGroup: UntypedFormGroup;
  @ViewChild("languageDropDown")
  languageDropDown: ElementRef;
  language: UntypedFormControl;
  languageOptions: any[];
  availableLangs: string[] | {id: string, label: string}[];
  activeLang: string;
  changeLanguage: string;
  ClientsLabel: string;
  SettingsLabel: string;
  NoticesLabel: string;
  uiConfig: TenantConfigService;
  yearLabel: string;
  taxReturnAlias: string;


  constructor(public userInfo: UserInfoService,
              public taxYearsService: TaxYearsService,
              public config: ConfigStateService,
              private translocoService: TranslocoService,
              private languageService: LanguageService,
  ) {
  }

  ngOnInit() {
    this.translocoService.selectTranslate('clients').subscribe(value => {this.ClientsLabel = value; });
    this.translocoService.selectTranslate('settings').subscribe(value => {this.SettingsLabel = value;}),
    this.translocoService.selectTranslate('notices').subscribe(value => {this.NoticesLabel = value;this.initMenu()}),

    this.formGroup = new UntypedFormGroup({});
    this.language = new UntypedFormControl();
    this.activeLang = this.translocoService.getActiveLang();
    this.availableLangs = this.translocoService.getAvailableLangs();

    // init language to 'en'
    if (!window.localStorage.getItem(Language_Local_Storage)) {
      this.changeLang(LanguageType.EN)
      this.language.setValue(LanguageType.EN)
    }else {
      this.language.setValue(window.localStorage.getItem(Language_Local_Storage))
    }
    
    this.formGroup.addControl("language", this.language);
    
    setTimeout(() => {
      this.initLanguageDropdown();
      this.languageDropDown.nativeElement.children[2].children[0].style.fontSize = '10px';
      this.languageDropDown.nativeElement.children[2].children[1].style.fontSize = '10px';
    });
  }

  initMenu (){
    const defaultTaxYr = this.taxYearsService.getCurrentTaxYear();
    this.menu = [
      {
        routerLink: "/search",
        label: "",
        className: "taxpayer-search",
        admin: false
      },
      {
        routerLink: "clients",
        queryParams: {taxYear: defaultTaxYr},
        label: this.ClientsLabel,
        className: "clients",
        admin: false,
        clientAdmin: false
      },
      {
        routerLink: "settings",
        label: this.SettingsLabel,
        className: "settings",
        admin: true
      },
      {
        routerLink: "notices",
        label: this.NoticesLabel,
        className: "notices",
        semanticUiIcon: "ui icon copy outline",
        admin: false,
        visible: () => this.config.featureFlags.notices,
      },
    ];
  }

  initLanguageDropdown() {
    $(this.languageDropDown.nativeElement).dropdown({
      values: [
        {
          value: LanguageType.EN,
          name: "A/語 (English)",
          selected: this.language.value === LanguageType.EN,
        },
        {
          value: LanguageType.JA,
          name: "A/語 (Japanese)",
          selected: this.language.value === LanguageType.JA,
        }
      ],
      placeholder: "Select...",
      fullTextSearch: "exact",
      preserveHTML: false,
      direction: 'upward',
      onChange: (value) => {
        this.changeLanguage = this.activeLang
        if (value && value !== "Null") {
          this.language.setValue(value);
          this.changeLang(value);
          this.languageService.storeLanguageType({language: this.activeLang}).subscribe()
        }
      },
    });
  }

  changeLang (lang: string) {
    this.translocoService.setActiveLang(lang);
    this.activeLang = lang
  }
  ngAfterViewInit() {
    const el = $(this.overlayEl.nativeElement);
    if (el.modal('is active')) {
      el.modal('hide');
    }
  }

  logout() {
    const el = $(this.overlayEl.nativeElement);
    el.modal({ closable: false }).modal('show');
    this.userInfo.logout();
  }
}
